import React from 'react';
import Lottie from 'lottie-react';
import errorPageNotFoundConfusedRobot from '../components/errorPageNotFoundConfusedRobot.json';
import {Container, Row, Col} from 'reactstrap';

const NotFound = () => {
  return (
    <Container>
      <Row>
        <Col md={{size: 8, offset: 2}}>
          <Lottie animationData={errorPageNotFoundConfusedRobot} />
        </Col>
      </Row>
    </Container>
  );
};

export default NotFound;
